import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useState } from "react";

const PaymentGateway = ({
  processingPayment,
  setProcessingPayment,
  paymentDetails,
  setPaymentDetails,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();
    setProcessingPayment(true);

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      setProcessingPayment(false);
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      redirect: "if_required",

      // confirmParams: {
      //   // return_url: "https://localhost:3000",
      //   redirect: "if_required",
      // },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log("ERROR: ", result);
      setPaymentDetails({
        error: result.error,
      });
    } else {
      console.log("SUCCESS: ", result);
      setPaymentDetails({
        success: result.paymentIntent,
      });
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
    setProcessingPayment(false);
  };
  return (
    <form onSubmit={handleSubmit}>
      {stripe ? <PaymentElement /> : "Loading..."}
      {processingPayment ? (
        <button className="btn btn-primary btn-small">Processing...</button>
      ) : (
        <button className="btn btn-primary btn-small" disabled={!stripe}>
          Pay
        </button>
      )}
    </form>
  );
};

export default PaymentGateway;
